import type { CalculateLoanRequest } from 'aem-libs-api/src/services/building-savings-product/v1/types'
import { createInletStore } from 'aem-libs-react-components/src/store/createInletStore'

import type { LoanDurationMaxParams, LoansConsolidationParams } from './types'
import { calculateLoanDuration } from './utils/calculateLoanDuration'

export type LoansConsolidationInputType = CalculateLoanRequest & {
  monthlyPayment: number
  extraLoanAmount: number
  loanDuration: number
}

export const loansConsolidationStore = createInletStore(
  null as unknown as LoansConsolidationInputType,
  null,
  (set) => ({
    setLoanAmount: (loanAmount: number, loanDurationMaxParams: LoanDurationMaxParams) =>
      set((request) => {
        return {
          ...request,
          loanAmount,
          loanDuration: calculateLoanDuration(
            loanAmount,
            request.extraLoanAmount,
            request.loanDuration,
            loanDurationMaxParams
          )
        }
      }),
    setMonthlyPayment: (monthlyPayment: number) => set((request) => ({ ...request, monthlyPayment })),
    setExtraLoanAmount: (extraLoanAmount: number, loanDurationMaxParams: LoanDurationMaxParams) =>
      set((request) => {
        return {
          ...request,
          extraLoanAmount,
          loanDuration: calculateLoanDuration(
            request.loanAmount,
            extraLoanAmount,
            request.loanDuration,
            loanDurationMaxParams
          )
        }
      }),
    setLoanDuration: (loanDuration: number) => set((request) => ({ ...request, loanDuration }))
  })
)

export const initStore = (params: LoansConsolidationParams) =>
  loansConsolidationStore
    .initialize()
    .map(() => ({
      loanAmount: params.loanInputConfig.default,
      monthlyPayment: params.paymentInputConfig.default,
      extraLoanAmount: params.extraLoanInputConfig.default,
      loanDuration: params.loanDurationInputConfig.default
    }))
    .use()
